module.exports = __webpack_public_path__ + "static/media/logo-nebulas.c17d06c3.svg";